export default "__VITE_ASSET__fa2a20a0__"